import React from "react";
import Home from "./screens/Home";
import MoreWork from "./screens/MoreWork";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/morework">
          <MoreWork />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
